import { useLayoutEffect, useState, useSyncExternalStore } from "react";
import { Spin } from "antd";
import {
  getRequestActivitySnapshot,
  subscribeRequestActivity,
} from "../../utils/requestActivity";
import "./AppLoader.css";

const AppLoader = ({
  className = "",
  control = false,
  overlay = false,
  label = "Loading",
  size = "large",
}) => (
  <div
    className={`app-loader ${overlay ? "app-loader--overlay" : control ? "app-loader--control" : "app-loader--inline"} app-loader--${size} ${className}`.trim()}
    role="status"
    aria-label={label}
    aria-live="polite"
  >
    <Spin
      className="app-loader__spinner"
      size={size === "small" ? "small" : "large"}
      spinning
      aria-hidden="true"
    />
    <span className="app-loader__label">{label}</span>
  </div>
);

export const TableLoaderIcon = () => (
  <AppLoader label="Loading table" size="large" />
);

export const ControlLoaderIcon = ({ className = "" }) => (
  <AppLoader
    className={className}
    control
    label="Loading suggestions"
    size="small"
  />
);

export const GlobalLoader = () => {
  const active = useSyncExternalStore(
    subscribeRequestActivity,
    getRequestActivitySnapshot,
    getRequestActivitySnapshot
  );
  const [visible, setVisible] = useState(active);

  useLayoutEffect(() => {
    if (active) {
      setVisible(true);
      return undefined;
    }

    if (!visible) return undefined;

    const scheduleFrame = window.requestAnimationFrame.bind(window);
    const cancelFrame = window.cancelAnimationFrame.bind(window);
    let secondFrame;
    const firstFrame = scheduleFrame(() => {
      secondFrame = scheduleFrame(() => setVisible(false));
    });

    return () => {
      cancelFrame(firstFrame);
      if (secondFrame !== undefined) cancelFrame(secondFrame);
    };
  }, [active, visible]);

  useLayoutEffect(() => {
    document.body.classList.toggle("app-loader-active", visible);
    return () => document.body.classList.remove("app-loader-active");
  }, [visible]);

  return visible ? <AppLoader overlay /> : null;
};

export default AppLoader;
